module.exports = __webpack_public_path__ + "img/companyIntro23.095a400c.png";